module.exports = require("core-js/modules/web.timers.js");